import {Box, Skeleton, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {FdicIcon} from '@/app/main/splits/components/FdicIcon';
import {AppButton, AppButtonVariant} from '@/app/shared-components';
import {InviterAvatar} from '@/app/shared-components/InviterAvatar/InviterAvatar';

interface GroupsInvitationCardProps {
  inviterName: string;
  groupName: string;
  isLoadingSplitData: boolean;
  onContinueFromLanding: () => void;
}

export function GroupsInvitationCard({
  inviterName,
  groupName,
  isLoadingSplitData,
  onContinueFromLanding,
}: GroupsInvitationCardProps) {
  const {t} = useTranslation();

  return (
    <Box
      component="div"
      className="splits-landing-card splits-landing-card-invitation">
      <Box
        component="div"
        className="splits-landing-card-fdic">
        <FdicIcon />
      </Box>
      <Box className="splits-landing-card-invitation-body">
        <InviterAvatar inviterName={inviterName} />
        {isLoadingSplitData ? (
          <>
            <Skeleton
              variant="text"
              animation="wave"
              width="80%"
              className="mx-auto text-[1.5rem]"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width="100%"
              className="text-[1rem]"
            />
          </>
        ) : (
          <>
            <Typography
              className="splits-landing-headline"
              component="h1">
              {t('groups.landing.invitation_title', {
                name: inviterName,
                group: groupName,
              })}
            </Typography>
            <Typography className="splits-landing-description">
              {t('groups.landing.invitation_description')}
            </Typography>
          </>
        )}
        <AppButton
          id="splits-landing-continue"
          onClick={onContinueFromLanding}
          label={t('groups.landing.continue')}
          variant={AppButtonVariant.onPrimary}
        />
      </Box>
    </Box>
  );
}
